import React from "react";

export const SearchBar = ({ searching, searchTerm, setSearchTerm }) => (
	<div className="searchbar-wrapper" style={{ padding: '8px 20px' }}>
		{/* <a className="float-left button border white px-32 icon-btn filterbar-btn-mobile" onClick={() => {this.toggleMobile('mobile_filters')}}>
			<img src="images/png-icons/filter-grey.png" />
		</a> */}
		<div className="search-field-container">
			<input className="search-input-field no-margin" type="text" placeholder = "Search Vehicles" id="searchbar" value={searchTerm} onChange={(e) => {setSearchTerm(e.target.value)}} />

			{searching && (
				<div className="loading-wrapper">
					<div className="lds-ring bkg-border-primary"><div></div><div></div><div></div><div></div></div>
				</div>
			)}

			{searchTerm?.length > 0 && !searching && (
				<a className = "close-icon" onClick={()=>{setSearchTerm('')}}>
					<img src = "images/png-icons/close-grey.png"/>
				</a>
			)}
		</div>
	</div>
);
